import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';
import getDevRouters from '../../customApp/router';

class AppRouter extends Component {
  render() {
    const { url } = this.props;
    return (
      <Switch>

        {/* <Route
          exact
          path={`${url}/country`}
          component={asyncComponent(() => import('../Settings/Country'))}
        /> */}

        <Route
          exact
          path={`${url}/city`}
          component={asyncComponent(() => import('../Settings/City'))}
        />
        
        <Route
          exact
          path={`${url}/location`}
          component={asyncComponent(() => import('../Settings/Location'))}
        />

        {/* <Route
          exact
          path={`${url}/template`}
          component={asyncComponent(() => import('../Settings/Template'))}
        /> */}

        {/* <Route
          exact
          path={`${url}/container`}
          component={asyncComponent(() => import('../Settings/Container'))}
        /> */}

        {/* <Route
          exact
          path={`${url}/interval`}
          component={asyncComponent(() => import('../Settings/Interval'))}
        /> */}

        <Route
          exact
          path={`${url}/device`}
          component={asyncComponent(() => import('../Settings/Device'))}
        />

        <Route
          exact
          path={`${url}/advertiser`}
          component={asyncComponent(() => import('../Settings/Advertiser'))}
        />
          {/* <Route
              exact
              path={`${url}/category`}
              component={asyncComponent(() => import('../Settings/Category'))}
          /> */}

        <Route
          exact
          path={`${url}/campaign/`}
          component={asyncComponent(() => import('../Campaign'))}
        />

        <Route
          exact
          path={`${url}/campaign/:id`}
          component={asyncComponent(() => import('../Campaign/List'))}
        />

        <Route
          exact
          path={`${url}/campaign/:adv/add`}
          component={asyncComponent(() => import('../Campaign/Manage/Campaign'))}
        />

        <Route
          exact
          path={`${url}/campaign/:adv/edit/:id`}
          component={asyncComponent(() => import('../Campaign/Manage/Campaign'))}
        />

        <Route
          exact
          path={`${url}/media/`}
          component={asyncComponent(() => import('../Media'))}
        />

        <Route
          exact
          path={`${url}/media/:id`}
          component={asyncComponent(() => import('../Media/Browser'))}
        />
          {/* <Route
              exact
              path={`${url}/events/`}
              component={asyncComponent(() => import('../Event/Calendar'))}
          /> */}

          <Route
              exact
              path={`${url}/scenarios/`}
              component={asyncComponent(() => import('../Scenarios'))}
          />
          <Route
              exact
              path={`${url}/scenarios/:id`}
              component={asyncComponent(() => import('../Scenarios/DeviceScenarios'))}
          />
        {getDevRouters(url)}
      </Switch>
    );
  }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/containers/App/AppRouter.js